import type { VideoResource } from "api/generated";
import type { Video } from "shared/types";

export const mapVideo = (resource: VideoResource): Video => ({
  id: resource.id,
  name: resource.name,
  url: resource.url,
});

export const mapVideos = (resources: VideoResource[]): Video[] =>
  resources.map(mapVideo);
